var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsOptional } from 'class-validator';
import { TrainingReminderTime } from '../../user/enums/training-reminder-time.enum.js';
/**
 * What the settings link's page may change (TM-9527): the email switches, under
 * the names `NotificationSettingsEmailSwitchesDto` reads them, and the training
 * reminder's send time — the one setting that shapes when a mail arrives rather
 * than whether. The global `forbidNonWhitelisted` pipe rejects any other field,
 * so the link can never reach the in-app or push switches or an id.
 */
export class UpdateNotificationSettingsPublicDto {
    emailNotificationRegistrationEnabled;
    emailNotificationShopEnabled;
    emailNotificationPatientHandOverEnabled;
    emailNotificationAppointmentEnabled;
    emailNotificationExerciseProgramEnabled;
    emailNotificationTrainingReminderEnabled;
    emailNotificationProgramStatsEnabled;
    emailNotificationInvoicesEnabled;
    trainingReminderTime;
}
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateNotificationSettingsPublicDto.prototype, "emailNotificationRegistrationEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateNotificationSettingsPublicDto.prototype, "emailNotificationShopEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateNotificationSettingsPublicDto.prototype, "emailNotificationPatientHandOverEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateNotificationSettingsPublicDto.prototype, "emailNotificationAppointmentEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateNotificationSettingsPublicDto.prototype, "emailNotificationExerciseProgramEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateNotificationSettingsPublicDto.prototype, "emailNotificationTrainingReminderEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateNotificationSettingsPublicDto.prototype, "emailNotificationProgramStatsEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateNotificationSettingsPublicDto.prototype, "emailNotificationInvoicesEnabled", void 0);
__decorate([
    Expose(),
    IsEnum(TrainingReminderTime),
    IsOptional(),
    __metadata("design:type", String)
], UpdateNotificationSettingsPublicDto.prototype, "trainingReminderTime", void 0);
//# sourceMappingURL=update-notification-settings-public.dto.js.map